






import { ProvideReactive, Prop, Vue, Component } from 'vue-property-decorator'

@Component({ inject: [] })
export default class Tabs extends Vue {
    @Prop({ default: null }) readonly initial!: string|null
    @ProvideReactive() activeTab: string = null

    mounted(): void {
        this.$on('activate', this.onActivate)
        this.onActivate(this.initial)
    }

    onActivate(tabName: string|null): void {
        this.activeTab = tabName
    }
}
